var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1663638628983,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 20414,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928.9 409c-8.2-23.2-29-39.9-54.2-43.7l-210-30.7-91.3-186.8c-11-22.7-35.1-37.5-61.4-37.5-26.2 0-50.2 14.7-61.2 37.4l-91.3 186.8-210.3 30.8C124 369 103.3 385.7 95.1 409 87 432.6 93 458.1 111 475.7l154.2 151.5-35.8 210.2c-4.4 24.9 6.3 49.5 28 64.3 11.4 7.7 24.8 11.8 38.9 11.8 11.4 0 22.6-2.7 32.7-8l182.9-97.2 183.7 97.5c22.1 11.4 50.3 9.8 71.4-4.1 21.4-14.6 32-39.3 27.7-64.2l-35.8-210.2 154.3-151.8c17.8-17.4 23.8-42.9 15.7-66.5z m-53.6 28.3L711 598.8c-6.3 6.2-9.2 15.1-7.7 23.8l38.1 224.2c0.7 4-1.1 7.7-4.7 10.2-4.4 3-12 3.1-16.1 1l-196-104c-7.9-4.2-17.4-4.1-25.4 0L303.8 857.9c-4.8 2.5-11.9 2.2-16.1-0.7-1.9-1.2-6.1-4.8-5.1-10.5l38.2-224.2c1.5-8.7-1.3-17.6-7.7-23.8L148.8 437.3c-2.9-2.9-4-6.8-2.7-10.3 1.5-4.3 5.7-7.4 11-8.2l224.3-32.9c8.8-1.3 16.4-6.9 20.4-14.8l97.6-199.6c2.1-4.2 7.2-7.1 12.7-7.1 5.6 0 10.8 2.8 12.8 7.1l97.6 199.6c3.9 8 11.5 13.6 20.4 14.8L867 418.7c5.4 0.8 9.7 4 11.1 8 1.1 3.8 0.1 7.7-2.8 10.6z m0 0",
    "p-id": 20415,
    fill: "#f5bb4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.6868b0a3.svg";
export { ForwardRef as ReactComponent };